// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateProfileProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitUpdateProfileProfessionalApi = createAsyncThunk("hitUpdateProfileProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + updateProfileProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const UpdateProfileProfessionalSlice = createSlice({
  name: "updateProfileProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateProfileProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateProfileProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateProfileProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateProfileProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateProfileProfessionalData } = UpdateProfileProfessionalSlice.actions;
export default UpdateProfileProfessionalSlice.reducer;
